import { sessionFetch } from '../../../utils/sessionFetch';
import { getServerEndpoint, getSubdomain } from '../../../utils/utils';
import { getAuthToken } from '../../../utils/login';

const API_KEY = '453dabb4-7645-4626-a1bb-477dff3aa557';
const DEFAULT_RETRIES = 2;
const RETRY_BASE_DELAY_MS = 150;

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const postCopilotMonitoringEvent = async (endpointPath, payload, options = {}) => {
    const retries = Number.isInteger(options?.retries) && options.retries >= 0
        ? options.retries
        : DEFAULT_RETRIES;
    const colla = getSubdomain();
    const serverEndpoint = getServerEndpoint(colla);

    for (let attempt = 0; attempt <= retries; attempt += 1) {
        const token = getAuthToken();
        if (!token) {
            return { ok: false, skipped: true, reason: 'missing_token' };
        }

        try {
            const response = await sessionFetch(`${serverEndpoint}${endpointPath}`, {
                method: 'POST',
                headers: {
                    'x-api-key': API_KEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
                keepalive: true,
            });

            if (response.ok) {
                return { ok: true };
            }

            if (response.status < 500 || attempt === retries) {
                return { ok: false, status: response.status };
            }
        } catch (error) {
            if (attempt === retries) {
                return {
                    ok: false,
                    error: error?.message || String(error),
                };
            }
        }

        await wait(RETRY_BASE_DELAY_MS * (attempt + 1));
    }

    return { ok: false, reason: 'retry_exhausted' };
};

export const trackCopilotSessionShown = (payload, options = {}) => postCopilotMonitoringEvent(
    '/api/pissarra/copilot/monitor/session-shown',
    payload,
    options
);

export const trackCopilotSessionDecision = (payload, options = {}) => postCopilotMonitoringEvent(
    '/api/pissarra/copilot/monitor/session-decision',
    payload,
    options
);
